import React, { useState } from "react";
import styled from "styled-components";
import { Add, ArrowLeft, Remove } from "@material-ui/icons";
import { useDispatch, useSelector } from "react-redux";

import Navbar from "./../components/Navbar/Navbar";
import Announcement from "./../components/Announcement/Announcement";
import Footer from "./../components/Footer/Footer";
import { mobile } from "./../responsive";
import { decreaseProduct } from "../redux/cartRedux";
import { Link } from "react-router-dom";
import { publicRequest } from "./../request";

const Container = styled.div``;

const Wrapper = styled.div`
  padding: 20px;

  ${mobile({ padding: "10px" })}
`;

const Title = styled.h1`
  font-weight: 300;
  text-align: center;
`;

const Top = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px;
`;

const TopButton = styled.button`
  padding: 10px;
  cursor: pointer;
  font-weight: 600;
  border: ${(props) => props.type === "filled" && "none"};
  background-color: ${(props) =>
    props.type === "filled" ? "black" : "transparent"};
  color: ${(props) => props.type === "filled" && "white"};
`;

const TopTexts = styled.div`
  ${mobile({ display: "none" })}
`;

const TopText = styled.span`
  text-decoration: underline;
  cursor: pointer;
  margin: 0px 10px;
`;

const Bottom = styled.div`
  display: flex;
  justify-content: space-between;

  ${mobile({ flexDirection: "column" })}
`;

const Info = styled.div`
  flex: 3;
`;

const Product = styled.div`
  display: flex;
  justify-content: space-between;
  background-color: #e5e4e2;

  ${mobile({ flexDirection: "column" })}
`;

const ProductDetail = styled.div`
  flex: 2;
  display: flex;
`;

const Image = styled.img`
  width: 200px;
`;

const Details = styled.div`
  padding: 20px;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
`;

const ProductName = styled.span``;

const ProductId = styled.span``;

const ProductColor = styled.div`
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background-color: ${(props) => props.color};
`;

const ProductSize = styled.span``;

const PriceDetail = styled.span`
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

const ProductAmountContainer = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 20px;
`;

const ProductAmount = styled.div`
  font-size: 24px;
  margin: 5px;

  ${mobile({ margin: "5px 15px" })}
`;

const ProductPrice = styled.div`
  font-size: 30px;
  font-weight: 200;

  ${mobile({ marginBottom: "20px" })}
`;

const Hr = styled.hr`
  background-color: white;
  border: none;
  height: 20px;
`;

const Summary = styled.div`
  flex: 1;
  border: 0.5px solid lightgray;
  border-radius: 10px;
  padding: 20px;
  height: 50vh;
`;

const SummaryTitle = styled.h1`
  font-weight: 200;
`;

const SummaryItem = styled.div`
  margin: 30px 0px;
  display: flex;
  justify-content: space-between;
  font-weight: ${(props) => props.type === "total" && "500"};
  font-size: ${(props) => props.type === "total" && "24px"};
`;

const SummaryItemText = styled.span``;

const SummaryItemPrice = styled.span``;

const SummaryButton = styled.button`
  width: 100%;
  padding: 10px;
  background-color: black;
  font-weight: 600;
  color: white;
`;

const NoCart = styled.h1`
  /* text-align: center; */

  display: flex;
  align-items: center;
  justify-content: center;
`;

const GoBack = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 10px 0px;
`;

const Cart = () => {
  const cart = useSelector((state) => state.cart);
  // const [stripeToken, setStripeToken] = useState(null);
  const [quantity, setQuantity] = useState(1);
  const dispatch = useDispatch();

  console.log(cart);

  // const onToken = (token) => {
  //   setStripeToken(token);
  // };

  // console.log(stripeToken);

  const handleCheckout = async () => {
    try {
      const res = await publicRequest.post("/checkout/payment", {
        cartProducts: cart.products,
      });
      // console.log(res.data.url);

      if (res.data.url) {
        window.location.href = res.data.url;
      }
    } catch (err) {
      console.log(err.message);
    }
  };

  const handleDecreaseCart = (product) => {
    dispatch(decreaseProduct(product));
  };

  return (
    <Container>
      <Navbar />
      <Announcement />
      <Wrapper>
        <Title>YOUR BAG</Title>
        <Top>
          <TopButton>CONTINUE SHOPPING</TopButton>
          <TopTexts>
            <TopText>Shopping Bag (2)</TopText>
            <TopText>Your Wishlist (0)</TopText>
          </TopTexts>
          <TopButton type="filled">CHECKOUT NOW</TopButton>
        </Top>
        <Bottom>
          <Info>
            {!cart.cartTotal && (
              <>
                <NoCart>
                  Start Shopping Now! <br />
                </NoCart>
                <GoBack>
                  <Link
                    to="/"
                    style={{
                      // textDecoration: "none",
                      color: "black",
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    <ArrowLeft fontSize="large" />
                    HOME
                  </Link>
                </GoBack>
              </>
            )}
            {cart.cartProducts?.map((product) => (
              <Product key={product._id}>
                {/* <Hr /> */}
                <ProductDetail>
                  <Image src={product.img} />
                  <Details>
                    <ProductName>
                      <b>Product:</b> {product.title}
                    </ProductName>
                    <ProductId>
                      <b>ID:</b> {product._id}
                    </ProductId>
                    <ProductColor color={product.color} />
                    <ProductSize>
                      <b>Size:</b> {product.size}
                    </ProductSize>
                  </Details>
                </ProductDetail>
                <PriceDetail>
                  <ProductAmountContainer>
                    <Add />
                    <ProductAmount>{product.cartQuantity}</ProductAmount>
                    <Remove onClick={() => handleDecreaseCart(product)} />
                  </ProductAmountContainer>
                  <ProductPrice>
                    $ {(product.price * product.quantity).toFixed(1)}
                  </ProductPrice>
                </PriceDetail>
              </Product>
            ))}
          </Info>
          <Summary>
            <SummaryTitle>ORDER SUMMARY</SummaryTitle>
            <SummaryItem>
              <SummaryItemText>Subtotal</SummaryItemText>
              <SummaryItemPrice>$ {cart.cartTotal.toFixed(1)}</SummaryItemPrice>
            </SummaryItem>
            <SummaryItem>
              <SummaryItemText>Estimated Shipping</SummaryItemText>
              <SummaryItemPrice>$ 4.90</SummaryItemPrice>
            </SummaryItem>
            <SummaryItem>
              <SummaryItemText>Shipping Discount</SummaryItemText>
              <SummaryItemPrice>$ -4.90</SummaryItemPrice>
            </SummaryItem>
            <SummaryItem type="total">
              <SummaryItemText>Total</SummaryItemText>
              <SummaryItemPrice>$ {cart.cartTotal.toFixed(1)}</SummaryItemPrice>
            </SummaryItem>
            {/* <StripeCheckout
              name="Shreyas Shop"
              image="https://w7.pngwing.com/pngs/340/946/png-transparent-avatar-user-computer-icons-software-developer-avatar-child-face-heroes.png"
              billingAddress
              shippingAddress
              description={`Your total is $ ${cart.total}`}
              amount={cart.total * 100}
              token={onToken}
              stripeKey={KEY}
            > */}
            <SummaryButton onClick={handleCheckout}>CHECKOUT NOW</SummaryButton>
            {/* </StripeCheckout> */}
          </Summary>
        </Bottom>
      </Wrapper>
      <Footer />
    </Container>
  );
};

export default Cart;
